/* Footer: phone accordions for the menu and contact columns.
   From 750 px up the toggle buttons are hidden and every panel is visible (CSS), so nothing here has an effect. */
if (!customElements.get('lmb-footer')) {
  customElements.define(
    'lmb-footer',
    class LmbFooter extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        // Theme editor: selecting a column block opens it so the merchant can see its links.
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get singleOpen() {
        return this.dataset.accordion !== 'independent';
      }

      get items() {
        return Array.from(this.querySelectorAll('.footer__col--accordion'));
      }

      onClick(event) {
        const toggle = event.target.closest('.footer__toggle');
        if (!toggle || !this.contains(toggle)) return;
        const item = toggle.closest('.footer__col--accordion');
        if (item) this.setOpen(item, !item.classList.contains('is-open'));
      }

      onBlockSelect(event) {
        const target = event.target;
        if (!(target instanceof Element) || !this.contains(target)) return;
        const item = target.closest('.footer__col--accordion');
        if (item) this.setOpen(item, true);
      }

      setOpen(item, open) {
        if (open && this.singleOpen) {
          this.items.forEach((other) => {
            if (other !== item && other.classList.contains('is-open')) this.setOpen(other, false);
          });
        }
        item.classList.toggle('is-open', open);
        const toggle = item.querySelector('.footer__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
      }
    }
  );
}
